import { gql } from '@apollo/client';

export const ADD_EXTERNAL_NUMBER_MUTATION = gql`
  mutation AddExternalNumberMutation($agentID: ID!, $input: AgentPhoneNumberInput!) {
    addExternalNumber(agentID: $agentID, input: $input) {
      ID
      isEnabled
      phoneNumber
      digitConfirmationDisabled
    }
  }
`;
